// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3VIBw","inner":"Footer_inner__w7qtk","nextIcon":"Footer_nextIcon__2kJ_4","innerLeft":"Footer_innerLeft__2tPFZ"};